import { defineMessages } from 'react-intl';

export default defineMessages({
    changeDesignatedPersonTitle: {
        id: 'wmic.policy-change.component.designated-person.changeDesignatedPersonTitle',
        defaultMessage: 'Add Or Update Recipient For Notice Of Cancellation Or Nonrenewal'
    }
});